// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"ebfd5a96","157":"85d70e30","372":"b5164a53"}[chunkId] + ".chunk.js";
};